// THIS FILE IS GENERATED, DO NOT EDIT!
/* eslint-disable */
import * as Types from '@h5s/dtos-api';

import { LocalDate, LocalDateTime, LocalTime } from '@h5s/util-date';
import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type UpdateInvoiceDataMutationVariables = Types.Exact<{
  upsertInvoiceDataDTO: Types.UpsertInvoiceDataDtoInput;
}>;


export type UpdateInvoiceDataMutationResult = { __typename?: 'Mutation', updateInvoiceData: boolean };

export const UpdateInvoiceDataGql = gql`
    mutation UpdateInvoiceData($upsertInvoiceDataDTO: UpsertInvoiceDataDTOInput!) {
  updateInvoiceData(upsertInvoiceDataDTO: $upsertInvoiceDataDTO)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateInvoiceDataInjectable extends Apollo.Mutation<UpdateInvoiceDataMutationResult, UpdateInvoiceDataMutationVariables> {
    override document = UpdateInvoiceDataGql;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
/* eslint-enable */